export default __webpack_public_path__ + "static/media/logoErr.4c46b558.svg";